import DailyDeliveryPlan from "../DailyPlan";
import { GroupedDeliveryTripsSortTypes } from "../../../configs/sortTypes";
import { GroupedDeliveryTripsFilterType } from "../../../configs/filterTypes";
import { DeliveryTripRow, DeliveryTripRowProps } from "./DeliveryTripTable";
import ListView from "../../../shared/components/ListView";
import { TableColumns } from "../../../configs/deliverytrips";
import { useState } from "react";
import styled from "styled-components";
import { TabContainer, TabHeader, Tab, TabContent } from "../../../shared/components/TabBar/Styled";
import { GroupedDeliveryTrips } from "../../../configs/deliveryTrip";

const DeliveryTab = styled(Tab)`
    font-family: "Noto Sans", sans-serif;
    flex-shrink: 0;
`;

const Content = ({
    handleSelectionChange,
    activeTab,
    onTabChange,
    planActionsContainer,
}: {
    handleSelectionChange: (selectedItems: any[]) => void;
    activeTab: string;
    onTabChange: (tab: string) => void;
    planActionsContainer: HTMLDivElement | null;
}) => {
    const [refresh, setRefresh] = useState(false);
    const handleSwitch = (key: string) => {
        handleSelectionChange([]);
        onTabChange(key);
    };

    const handleRefresh = () => {
        setRefresh((prev) => !prev);
    };

    return (
        <TabContainer>
            <TabHeader role="tablist" aria-label="Vận chuyển">
                {[
                    { key: "list", label: GroupedDeliveryTrips.title },
                    { key: "plan", label: "Kế hoạch giao hàng" },
                ].map(({ key, label }, index, tabs) => (
                    <DeliveryTab
                        key={key}
                        active={activeTab === key}
                        role="tab"
                        id={`delivery-tab-${key}`}
                        aria-controls={`delivery-panel-${key}`}
                        aria-selected={activeTab === key}
                        tabIndex={activeTab === key ? 0 : -1}
                        onClick={() => handleSwitch(key)}
                        onKeyDown={(event) => {
                            const next =
                                event.key === "ArrowRight"
                                    ? (index + 1) % tabs.length
                                    : event.key === "ArrowLeft"
                                      ? (index + tabs.length - 1) % tabs.length
                                      : event.key === "Home"
                                        ? 0
                                        : event.key === "End"
                                          ? tabs.length - 1
                                          : -1;
                            if (next < 0) return;
                            event.preventDefault();
                            handleSwitch(tabs[next].key);
                            document.getElementById(`delivery-tab-${tabs[next].key}`)?.focus();
                        }}
                    >
                        <div className="text">{label}</div>
                    </DeliveryTab>
                ))}
            </TabHeader>
            <TabContent
                active
                direction="right"
                role="tabpanel"
                id={`delivery-panel-${activeTab}`}
                aria-labelledby={`delivery-tab-${activeTab}`}
            >
                {activeTab === "list" && (
                    <ListView
                        url="/product-flow/v2/delivery-trips/grouped/"
                        sortTypes={GroupedDeliveryTripsSortTypes}
                        filterTypes={GroupedDeliveryTripsFilterType}
                        rowElement={(props: DeliveryTripRowProps) => (
                            <DeliveryTripRow {...props} handleRefresh={handleRefresh} />
                        )}
                        tableColumns={TableColumns}
                        textString="Tìm kiếm theo từ khóa Biển số xe hoặc tên Đơn hàng"
                        refresh={refresh}
                        selectable={true}
                        onSelectionChange={handleSelectionChange}
                    />
                )}
                {activeTab === "plan" && <DailyDeliveryPlan actionsContainer={planActionsContainer} />}
            </TabContent>
        </TabContainer>
    );
};

export default Content;
